import type { BoardingDiscount, BoardingAccommodationTotals } from "../type/healthcare";
export function validBoardingDiscount(type: unknown, value: unknown): boolean {
  if (type !== "amount" && type !== "percentage") return false;
  if (typeof value !== "number" && typeof value !== "string") return false;
  if (String(value).trim() === "") return false;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 && (type !== "percentage" || number <= 100);
}
export function readBoardingDiscount(raw: any): BoardingDiscount | null {
  return raw && validBoardingDiscount(raw.type, raw.value)
    ? { type: raw.type, value: Number(raw.value) } : null;
}
// Only canonical server figures. Absence is never a fabricated zero.
export function readBoardingAccommodationTotals(raw: any): BoardingAccommodationTotals {
  const money = (value: unknown): number | null =>
    (typeof value === "number" || typeof value === "string") && String(value).trim() !== ""
      && Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : null;
  return {
    accommodationSubtotal: money(raw?.accommodation_subtotal),
    accommodationDiscountAmount: money(raw?.accommodation_discount_amount),
    accommodationTotal: money(raw?.accommodation_total),
    discount: readBoardingDiscount(raw?.discount),
  };
}
export const boardingAccommodationRows = [
  ["accommodationSubtotal", "subtotal"],
  ["accommodationDiscountAmount", "applied"],
  ["accommodationTotal", "total"],
] as const;
